import { render, staticRenderFns } from "./LandList.vue?vue&type=template&id=e9138de8&scoped=true&"
import script from "./LandList.vue?vue&type=script&lang=js&"
export * from "./LandList.vue?vue&type=script&lang=js&"
import style0 from "./LandList.vue?vue&type=style&index=0&id=e9138de8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9138de8",
  null
  
)

export default component.exports